<template>
	<button title="Download" class="download" @click="download">
		<IconDownload />
		<form ref="form" method="POST" target="_blank" :action="url"></form>
	</button>
</template>

<script>
import { apiUrl } from '@/lib/api'
import IconDownload from 'mdi-vue/Download'
export default {
	name: 'DownloadButton',
	props: {
		id: Number
	},
	computed: {
		url() {
			return apiUrl(`/campaigns/${this.id}/download`)
		}
	},
	methods: {
		download() {
			this.$refs.form.submit()
		}
	},
	components: {
		IconDownload
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.download {
	@include circle-button(1.5rem);
}

form {
	display: none;
}
</style>
